import { useLocation } from 'react-router-dom';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGeneralContext } from '../../context/Context';

const FAB = () => {
  const { setFeedbackModalOpen } = useGeneralContext();
  const location = useLocation();

  if (location.pathname === '/contact' || location.pathname.startsWith('/entry')) {
    return <></>;
  }

  const handleClick = () => {
    setFeedbackModalOpen(true);
  };

  return (
    <button
      onClick={handleClick}
      className="tw-fixed tw-right-6 tw-bottom-6 tw-w-16 tw-h-16 tw-rounded-full tw-shadow-xl tw-bg-gradient-to-r tw-from-primary-500 tw-to-primary-600 hover:tw-from-primary-600 hover:tw-to-primary-700 tw-text-white tw-border-2 tw-border-white tw-cursor-pointer tw-transition-all tw-duration-300 hover:tw-scale-110 hover:tw-shadow-2xl tw-flex tw-items-center tw-justify-center tw-text-xl tw-group tw-z-50 lg:tw-block tw-hidden"
      aria-label="Contact Us - Chat with Tony"
      title="💬 Chat with Tony (Founder) - Click to get in touch!"
    >
      <FontAwesomeIcon
        icon={faPaperPlane}
        className="tw-transform tw-transition-transform tw-duration-200 group-hover:tw-rotate-6"
      />

      {/* Notification dot */}
      <span className="tw-absolute tw--top-1 tw--right-1 tw-w-6 tw-h-6 tw-bg-red-500 tw-text-white tw-rounded-full tw-text-xs tw-flex tw-items-center tw-justify-center tw-font-bold tw-shadow-md">
        💬
      </span>
    </button>
  );
};

export default FAB;
